// fileUtils.js
export const isPDFFile = (fileAsBase64, fileName) => {
  return fileAsBase64 && (
    fileAsBase64.startsWith('data:application/pdf') || 
    fileAsBase64.includes('application/pdf') ||
    fileName?.toLowerCase().endsWith('.pdf')
  );
};

export const getImageSrc = (fileAsBase64) => {
  if (!fileAsBase64) return '';
  return fileAsBase64.startsWith('data:') 
    ? fileAsBase64 
    : `data:image/jpeg;base64,${fileAsBase64}`;
};

export const getPDFSrc = (fileAsBase64) => {
  if (!fileAsBase64) return '';
  return fileAsBase64.startsWith('data:application/pdf') 
    ? fileAsBase64 
    : `data:application/pdf;base64,${fileAsBase64}`;
};
